import React, { useEffect, useState, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';
//Redux
import { get, isEmpty } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { groupNotificationList } from '../../../actions/groupNotificationAction';
//components
import CardLayout from '../../../components/DataTextCard/Layout';
import PageHeading from '../../../components/PageHeading';
import NoData from '../../../components/NoData';
import LoadingSkeleton from '../../../components/LoadingSkeleton';
import PopUpModal from '../../../components/PopUpModal';

const useStyles = makeStyles(theme => ({
  dialogCustomizedWidth: {
    [theme.breakpoints.up('xs')]: {
      'max-width': '100%'
    },
    [theme.breakpoints.up('sm')]: {
      'max-width': '80%'
    },
    [theme.breakpoints.up('md')]: {
      'max-width': '35%'
    },
    [theme.breakpoints.up('xl')]: {
      'max-width': '35%'
    }
  },
  dialogPosition: {
    position: 'absolute',
    right: '0px',
    top: '0px'
  }
}));

export default function GroupNotification() {
  const classes = useStyles();
  const childRef = useRef();
  // State
  const [isFetching, setIsFetching] = useState(false);
  const [selectedCard, setSelectedCard] = useState({});
  // Redux
  const dispatch = useDispatch();
  const loginData = useSelector(state =>
    get(state, 'loginReducer.data.jwt', {})
  );
  const groupNotificationDataList = useSelector(state =>
    get(state, 'groupNotificationReducer.data', [])
  );
  const errorMessage = useSelector(state =>
    get(state, 'groupNotificationReducer.errorMessage', '')
  );

  const populateContent = () => {
    switch (selectedCard.ContentType) {
      case 1:
        return (
          <iframe
            width="560"
            height="315"
            src={`https://www.youtube.com/embed/${get(
              selectedCard,
              'ContentDescription',
              ''
            )}`}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        );
      case 2:
        return (
          <iframe
            width="100%"
            frameBorder="0"
            src={get(selectedCard, 'ContentDescription', '')}
            className="embed-iframe"
            style={{ flexGrow: '1' }}
          />
        );
      case 3:
        return <img src={groupNotificationDataList[0].ContentDescription} />;
      case 4:
        return (
          <div className="flex-column flex-align-center height-100">
            <Button
              variant="contained"
              color="primary"
              onClick={() =>
                window.open(get(selectedCard, 'ContentDescription'))
              }
              style={{ width: '40%', alignSelf: 'flex-end' }}
            >
              Open PDF
            </Button>
            <iframe
              width="100%"
              frameBorder="0"
              src={get(selectedCard, 'ContentSubDescription', '')}
              className="embed-iframe mt-10"
              style={{ flexGrow: '1' }}
            />
          </div>
        );
    }
  };

  const header = <div> {selectedCard.ContentTitle} </div>;

  const body = (
    <div className="list-content height-100">{populateContent()}</div>
  );

  //Functions
  useEffect(() => {
    setIsFetching(true);
    groupNotificationList(loginData, dispatch).then(() => {
      setIsFetching(false);
    });
  }, []);

  const populateGroupNotificationList = () => {
    let list = [];
    if (!isEmpty(groupNotificationDataList))
      groupNotificationDataList.map((data, index) => {
        return list.push(
          <div
            topic={data.ContentTitle}
            key={index}
            handler={() => {
              setSelectedCard(data);
              childRef.current.handleClickOpen();
            }}
            popupDisabled={true}
          ></div>
        );
      });
    return list;
  };

  return (
    <React.Fragment>
      <PageHeading titlePrimary="Group " titleSecondary="Notification" />
      {isFetching ? (
        <LoadingSkeleton type="smallcardlist" />
      ) : !isEmpty(populateGroupNotificationList()) ? (
        <>
          <CardLayout value={0} index={0}>
            {populateGroupNotificationList()}
          </CardLayout>
        </>
      ) : (
        <NoData
          message={!isEmpty(errorMessage) ? errorMessage : 'No data Available'}
        />
      )}
      <PopUpModal
        ref={childRef}
        header={header}
        body={body}
        width={classes.dialogCustomizedWidth}
        position={classes.dialogPosition}
        fullScreen={true}
      />
    </React.Fragment>
  );
}
